import { Switch, SwitchProps } from "@mui/material";
import { ReactNode } from "react";
import useDisclosure from "../hooks/use-disclosure";
import { useSnackbar } from "../hooks/useSnackbar";
import { getErrorSnackbar, getSuccessSnackbar } from "../utils/utils";
import { FlexCenterWrapper } from "./DefaultNoDataWrapper";
import Flex from "./Flex";
import StatusModal from "./StatusModal";

const DEFAULT_CUSTOM_LABELS = {
  true: {
    label: "Active",
  },
  false: {
    label: "Inactive",
  },
};

type ToggleSwitchProps<T> = {
  checked?: boolean;
  switchVisible?: boolean;
  readOnly?: boolean;
  id?: T;
  content?: ReactNode | Element;
  onConfirm?: (e: boolean, id?: T) => Promise<any>;
  customLabels?: typeof DEFAULT_CUSTOM_LABELS;
  confirmButtonText?: string;
  cancelButtonText?: string;
} & SwitchProps;

/**
 * @warn must use onConfirm modified this component to use onConfirm
 * this component handle the logic for onConfirmation while status change
 * @description on Confirm make sure it open the confirmation modal while event trigger
 *
 * @author rajkumar rathod
 */
const ToggleSwitch = <T,>({
  checked,
  switchVisible = true,
  readOnly = false,
  onConfirm,
  customLabels = DEFAULT_CUSTOM_LABELS,
  content,
  id,
  confirmButtonText,
  cancelButtonText,
  ...others
}: ToggleSwitchProps<T>) => {
  /**
   * future reference 
   * req - to add background in switch
  function getBgColorWhileNonSelectable(): string {
    if (switchVisible) return "#1A1A1A0F";
    else return checked ? "#54913526" : "#FF000026";
  }

  function getColorWhileNonSelectable(): string | undefined {
    if (switchVisible) return;
    else return checked ? "#549135" : "#FF3300";
  }
   */

  /** status disclosure to maintain confirmation modal on every onClick */
  const statusDisclosure = useDisclosure(false);
  const showSnackbar = useSnackbar();
  /**
   * handle loading inside this component
   * so that we can reduce snippet for loading state
   */
  // const [isLoading, setIsLoading] = useLoading();

  return (
    <Flex
      borderRadius={2}
      // justifyContent={"center"}
      // alignItems={"center"}
      // textAlign={"center"}
      // bgcolor={getBgColorWhileNonSelectable()}
      // color={getColorWhileNonSelectable()}
      padding={"8px"}
      width={"100px"}
      gap={1}
    >
      {switchVisible && (
        <Switch
          {...others}
          checked={checked}
          disabled={readOnly}
          onChange={statusDisclosure.open}
          size="small"
        />
      )}

      {/* <Typography>
        {checked ? customLabels.true.label : customLabels.false.label}
      </Typography> */}

      <StatusModal
        w="36rem"
        id={id}
        // isLoading={isLoading}
        confirmButtonText={confirmButtonText}
        cancelButtonText={cancelButtonText}
        content={
          content
            ? ((<FlexCenterWrapper>{content}</FlexCenterWrapper>) as any)
            : "You want to change the status ?"
        }
        onConfirmation={(id) => {
          onConfirm?.(!checked, id)
            .then((res) => {
              showSnackbar(getSuccessSnackbar(res));
              statusDisclosure.close();
            })
            .catch((err) => showSnackbar(getErrorSnackbar(err)));
          // .finally(() => setIsLoading(false));
        }} //returning !prev value
        iconColor="primary.main"
        open={statusDisclosure.opened}
        onClose={statusDisclosure.close}
      />
    </Flex>
  );
};

export default ToggleSwitch;
